<template>
    <div class="saas-page profile-command-page">
        <div class="saas-hero card-saas profile-command-hero">
            <div class="saas-hero__main">
                <p class="saas-hero__crumb">
                    <router-link to="/user">{{ trans('user.user') }}</router-link>
                    <span class="px-1">/</span>
                    <span>{{ trans('user.contact') }}</span>
                </p>
                <h1 class="saas-hero__title">{{ userForm.first_name }} {{ userForm.last_name }}</h1>
                <p class="profile-command-hero__subtitle">{{ trans('user.contact') }} · {{ userForm.phone || trans('user.phone') }}</p>
            </div>
        </div>
        <div class="nk-block">
            <div class="card-saas card-saas--flush admin-user-profile-card">
                <div class="card-aside-wrap">
                    <div class="card-content">
                        <user-sidebar menu="contact" :id="id"></user-sidebar>
                        <div class="card-inner admin-user-form-inner">
                            <div class="nk-block">
                                <div class="nk-block-head admin-user-form-head">
                                    <h4 class="admin-user-section-title">{{trans('user.contact')}}</h4>
                                </div>
                                <form @submit.prevent="submit" @keydown="userForm.errors.clear($event.target.name)">
                                    <div class="row">
                                        <div class="col-12 col-md-6 form-group">
                                            <label for="">{{trans('user.phone')}}</label>
                                            <input class="form-control" type="text" value="" v-model="userForm.phone" name="phone" :placeholder="trans('user.phone')">
                                            <show-error :form-name="userForm" prop-name="phone"></show-error>
                                        </div>
                                        <div class="col-12 col-md-6 form-group">
                                            <label for="">{{trans('user.address_line_1')}}</label>
                                            <input class="form-control" type="text" value="" v-model="userForm.address_line_1" name="address_line_1" :placeholder="trans('user.address_line_1')">
                                            <show-error :form-name="userForm" prop-name="address_line_1"></show-error>
                                        </div>
                                        <div class="col-12 col-md-6 form-group">
                                            <label for="">{{trans('user.address_line_2')}}</label>
                                            <input class="form-control" type="text" value="" v-model="userForm.address_line_2" name="address_line_2" :placeholder="trans('user.address_line_2')">
                                            <show-error :form-name="userForm" prop-name="address_line_2"></show-error>
                                        </div>
                                        <div class="col-12 col-md-6 form-group">
                                            <label for="">{{trans('user.city')}}</label>
                                            <input class="form-control" type="text" value="" v-model="userForm.city" name="city" :placeholder="trans('user.city')">
                                            <show-error :form-name="userForm" prop-name="city"></show-error>
                                        </div>
                                        <div class="col-12 col-md-6 form-group">
                                            <label for="">{{trans('user.state')}}</label>
                                            <input class="form-control" type="text" value="" v-model="userForm.state" name="state" :placeholder="trans('user.state')">
                                            <show-error :form-name="userForm" prop-name="state"></show-error>
                                        </div>
                                        <div class="col-12 col-md-6 form-group">
                                            <label for="">{{trans('user.zipcode')}}</label>
                                            <input class="form-control" type="text" value="" v-model="userForm.zipcode" name="zipcode" :placeholder="trans('user.zipcode')">
                                            <show-error :form-name="userForm" prop-name="zipcode"></show-error>
                                        </div>
                                        <div class="col-12 col-md-6 form-group">
                                            <label for="">{{trans('user.country')}}</label>
                                            <select class="form-control" name="country_id" v-model="userForm.country_id">
                                                <option value="">{{trans('user.country')}}</option>
                                                <option v-for="country in countries" v-bind:value="country.value">{{country.text}}</option>
                                            </select>
                                            <show-error :form-name="userForm" prop-name="country_id"></show-error>
                                        </div>
                                    </div>
                                    <div class="admin-user-form-actions">
                                        <button type="submit" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid">{{trans('general.save')}}</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="card-aside card-aside-right user-aside toggle-slide toggle-slide-right toggle-break-xxl" data-content="userAside" data-toggle-screen="xxl" data-toggle-overlay="true" data-toggle-body="true">
                        <div class="card-inner-group" data-simplebar>
                            <user-summary :user="user"></user-summary>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import userSidebar from './user-sidebar'
    import userSummary from './summary'

    export default {
        components : { userSidebar,userSummary },
        data() {
            return {
                id:this.$route.params.id,
                userForm: new Form({
                    phone: '',
                    first_name: '',
                    last_name: '',
                    address_line_1: '',
                    address_line_2: '',
                    city: '',
                    state: '',
                    zipcode: '',
                    country_id: ''
                },false),
                countries: [],
                user: ''
            };
        },
        mounted(){
            if(!helper.hasPermission('edit-user')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }

            axios.get('/api/fetch/lists?lists=country')
                .then(response => response.data)
                .then(response => {
                    this.countries = response.data.country;
                })
                .catch(error => {
                    helper.showDataErrorMsg(error);
                });
            axios.get('/api/user/'+this.id)
                .then(response => response.data)
                .then(response => {
                    this.user = response.user;
                    this.userForm.phone = response.user.profile.phone;
                    this.userForm.first_name = response.user.profile.first_name;
                    this.userForm.last_name = response.user.profile.last_name;
                    this.userForm.address_line_1 = response.user.profile.address_line_1;
                    this.userForm.address_line_2 = response.user.profile.address_line_2;
                    this.userForm.city = response.user.profile.city;
                    this.userForm.state = response.user.profile.state;
                    this.userForm.zipcode = response.user.profile.zipcode;
                    this.userForm.country_id = response.user.profile.country_id || '';
                })
                .catch(error => {
                    helper.showDataErrorMsg(error);
                    this.$router.push('/user');
                })
        },
        methods: {
            submit(){
                this.userForm.patch('/api/user/'+this.id+'/contact')
                    .then(response => {
                        toastr.success(response.message);
                        this.user.profile.phone = this.userForm.phone;
                    })
                    .catch(error => {
                        helper.showErrorMsg(error);
                    });
            }
        }
    }
</script>

<style scoped>
.profile-command-page {
    --linear-accent: #625cf6;
    --linear-line: #e5e7eb;
    --linear-muted: #64748b;
}

.profile-command-hero,
.admin-user-profile-card {
    border-color: var(--linear-line);
    background: #ffffff;
}

.profile-command-hero__subtitle {
    margin: 0.25rem 0 0;
    color: var(--linear-muted);
    font-size: 0.8125rem;
    font-weight: 500;
}

.admin-user-form-inner {
    background: transparent;
}

.admin-user-section-title {
    color: #0f172a;
    font-weight: 600;
    letter-spacing: -0.02em;
}

.admin-user-form-actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 0.5rem;
}
</style>
